import React, { useMemo } from "react";
import { GeoJSONLayer } from "react-mapbox-gl";
import { decodePolyline } from "../../../PickupDropoff/decodePolyline";

const DriverDirection = ({ routes }) => {
  // Decode polylines on-demand only when map is rendered
  const geoJsonData = useMemo(() => {
    return {
      type: "FeatureCollection",
      features: routes.reduce((res, route) => {
        if (route?.display && (route?.coords?.length > 0 || route?.polylines)) {
          // Use existing coords if available, otherwise decode polylines lazily
          let coords = route?.coords;
          if ((!coords || coords.length === 0) && route?.polylines) {
            coords = decodePolyline(route.polylines).coords;
          }

          if (coords && coords.length > 0) {
            res.push({
              type: "Feature",
              properties: { color: route?.color },
              geometry: {
                type: "LineString",
                coordinates: coords.map((c) => [c.lng, c.lat])
              }
            });
          }
        }
        return res;
      }, [])
    };
  }, [routes]);

  return (
    <GeoJSONLayer
      data={geoJsonData}
      linePaint={{
        "line-color": ["get", "color"],
        "line-width": 3,
        "line-opacity": 0.8
      }}
    />
  );
};

export default React.memo(DriverDirection);
